import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import { CodeDiff } from 'v-code-diff';

interface Props {
  oldString: string;
  newString: string;
  context: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CodeDiffWrapper',
  props: {
    oldString: {},
    newString: {},
    context: {}
  },
  emits: ['CodeDiffMounted'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

onMounted(async () => {
  emit('CodeDiffMounted');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(CodeDiff), {
      "old-string": __props.oldString,
      "new-string": __props.newString,
      context: __props.context
    }, null, 8, ["old-string", "new-string", "context"])
  ]))
}
}

})